import { Button } from '@/components/Button'
import { Icon } from '@/icons'
import { Tariff as TariffEnum } from '@/services/Api/generated'
import {
  TariffNameMap,
  TariffPriceMap,
  tariffStore,
} from '@/domains/Site/store/Tariff.store'
import { formatNumber } from '@/utils/format'
import cn from 'classnames'
import { FunctionComponent, useCallback, useMemo } from 'react'
import styles from './TariffList.module.scss'

interface TariffListProps {
  className?: string
  onSelect(tariff: TariffEnum): void
}
export const TariffList: FunctionComponent<TariffListProps> = ({
  className,
  onSelect,
}) => {
  return (
    <div className={cn(className, styles.container)}>
      <div className={styles.list}>
        <Tariff tariff={TariffEnum.Self} onSelect={onSelect} />
        <Tariff tariff={TariffEnum.Optimal} onSelect={onSelect} />
        <Tariff tariff={TariffEnum.AllInclusive} onSelect={onSelect} />
        <Tariff tariff={TariffEnum.WithGuarantee} onSelect={onSelect} />
      </div>
    </div>
  )
}

interface TariffComponentProps {
  tariff: TariffEnum
  onSelect(tariff: TariffEnum): void
}
const Tariff: FunctionComponent<TariffComponentProps> = ({
  tariff,
  onSelect,
}) => {
  const name = useMemo(() => TariffNameMap[tariff], [tariff])
  const price = useMemo(() => TariffPriceMap[tariff], [tariff])
  const props = useMemo(() => tariffStore.getPropsByName(tariff), [tariff])

  const formatPrice = useMemo(() => formatNumber(price), [price])

  const select = useCallback(() => {
    onSelect(tariff)
  }, [tariff, onSelect])

  return (
    <div className={styles.item}>
      <div className={styles.header}>
        <span className={styles.name}>{name}</span>
        <span className={styles.price}>{formatPrice} ₽</span>
        <span className={styles.tax}>+ госпошлины</span>
      </div>
      <div className={styles.props}>
        {props.map((prop) => (
          <div className={styles.prop} key={prop}>
            <div className={styles.propIconWrap}>
              <Icon name="siteCheckCircle2" className={styles.propIconCheck} />
            </div>
            {prop}
          </div>
        ))}
      </div>
      <Button
        name="Выбрать"
        className={styles.selectButton}
        onClick={select}
      ></Button>
    </div>
  )
}
